const PAGE_ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  LOGIN: '/login',
  FORGETPASSWORD: '/forget-password',
  RESETPASSWORD: '/reset-password',
  ADMINPRODUCTION: '/admin-production',
  ADMINSTAFFING: '/admin-staffing',
  ADMINGAMES: '/admin-games',
  GAMES: '/games',
  PERIODS: '/periods',
  USERS: '/users',
  ADDUSER: '/add-user',
  ADDTPEUSER: '/add-tpe-user',
  MYACCOUNT: '/myaccount',
  SHIFTS: '/shifts',
  TEAMS: '/teams',
  ADDTEAM: '/add-team',
  NOTIFICATION: '/notification',
  BROADCASTNOTIFICATION: '/broadcast-notification',
  BROADCASTNOTIFICATIONUSERS: '/broadcast-notification-users/:userId',
  ADDBROADCASTNOTIFICATION: '/add-broadcast-notification',
  ADDSHIFT: '/add-shift',
  UPDATEUSER: '/user-details-update/:userId',

  ACTIVITYLOG: '/games/activity-log/:gameId',

  REPORT: '/report',
  REPORTPAGE: '/report-page',
  ASSIGNREQUEST: '/assing-request',
  ASSIGNGAME: '/assing-game/:id',
  REQUESTEDTOKEN: '/requested-token',
  INVOICE: '/invoice',
  INVOICE_DETAIL: '/invoice/:id',
};
export const API_ROUTES = {
  //RequestAssign
  assignRequest: '/v2/assign-request',
  assignRequestList: '/v2/assign-request/list',
  assignGameList: '/v2/assign-request/game/list',
  activeModeratorList: '/v2/active-moderator/list',
  assignGameToModerator: '/v2/assign-game-request',
  shuffleGame: '/v2/resuffle-games',
  unassignPeriod: '/v2/unassigned-periods',
  activeGameCount: '/v2/active-game-counts',

  //Task request(token)
  currentTaggingRequest: '/v2/tagging-request',
  sendTaggingRequest: '/v2/request-tagging',
  cancelTaggingRequest: '/v2/cancel-tagging-request',

  //notification
  notification: '/v2/users/notification-token',
  validateNotification: '/v2/users/validate-notification-token',
  notificationList: '/v2/notifications/list',
  markAs: '/v2/notifications/status',
  markAsAll: '/v2/notifications/all-status',
  notificationCount: '/v2/notifications/unread',
  notificationTableList: '/v2/admin/notifications/list',
  broadcastList: '/v2/notifications/broadcast/list',

  //BroadcastNotification
  addBroadcastNotification: '/v2/notifications/broadcast',
  facthBroadcastNotification: '/v2/notifications/recent-broadcast',
  markAsRead: '/v2/notifications/broadcast',
  BroadcastNotificationUserByid: '/v2/notifications/broadcast/users/list',
  //auth
  Login: '/v2/auth/login',
  forgetPassword: '/v2/auth/forget-password',
  resetMainPassword: '/v2/auth/reset-password',
  emailVerify: '/v2/auth/email-verify',

  GamesList: '/v2/games-list',
  UserMe: '/v2/user-me',
  progressGame: '/v2/set-progress-by-game-id',
  progressPeriod: '/v2/set-progress-by-period-id',
  gameProgress: '/v2/game-status-timer/:id',
  getComments: '/v2/get-comments/:id',
  getDealyComments: '/v2/games/comment',
  getDocument: '/v2/games/documents/:id',

  //game
  PeriodList: '/v2/period-list',
  updateGameList: '/v2/game',
  updatePeriodList: '/v2/period',
  documentList: '/v2/document-list',
  documentAdd: '/v2/document',
  updatePeriodStatus: '/v2/period-status',
  updateGameStatus: '/v2/game-status',
  activityLog: '/v2/admin/activity-logs',
  completedGameList: '/v2/completed-game-list',
  // user
  userGetById: '/v2/users/details',
  allUser: '/v2/users/get-all-users',
  resetPassword: '/v2/admin/reset-password',
  desabledUser: '/v2/admin/disable-user',
  deleteUser: '/v2/admin/delete-user',
  registerUser: '/v2/admin/create-user',
  tpeRegisterUser: '/v2/users/tpe-user-registration',
  editProfile: '/v2/admin/edit-profile',
  ProfileUpdate: '/v2/admin/update-profile',
  uploadFile: '/upload-file',
  updateFile: '/update-file',
  fetchGame: '/fetch-games',
  fatchAllTeam: '/v2/all-teams',
  leadUser: '/v2/users/get-lead-users',
  childUserList: '/v2/users/get-child-users',
  switchUser: '/v2/users/switch',

  //shift
  addShift: '/v2/admin/create-shift',
  fatchShift: '/v2/admin/shift-list',
  deleteShift: '/v2/admin/delete-shift',
  updateShift: '/v2/admin/update-shift',
  bulkAssginShift: '/v2/admin/shift/bulk-assign',
  bulkShiftUpdate: '/v2/admin/shift/find-and-assign-bulk',
  // clock in - out
  clockIn: '/v2/shift/clock-in',
  clockOut: '/v2/shift/clock-out',
  breakIn: '/v2/shift/break-in',
  breakOut: '/v2/shift/break-out',
  logAttendance: '/v2/shift/attendance-log',
  //logs
  clockInOutLogs: '/v2/shift/attendance-list',
  clockInOutLogsById: '/v2/admin/shift/attendance-list',
  //Dashboard
  productionStatus: '/v2/stats',
  chartData: '/v2/get-hourly-count-data',
  countChartData: '/v2/get-hourly-total-count-data',
  activeUserCounts: '/v2/admin/active-user-stats',
  idleUserCounts: '/v2/admin/idle-user-stats',
  leadershipTable: '/v2/admin/leadership',
  shiftCountGraph: '/v2/admin/staffing-visuals',
  hourlyActivitySummaryGraph: '/v2/hourly-activity-summary',
  idleReportGraph: '/v2/admin/idle-user-report',
  underProgresss: '/v2/games/under-progresss',
  inQC: '/v2/games/in-qc',

  //token
  refreshToken: '/v2/auth/refresh-token',

  //assign Moderator
  assignModerator: '/v2/assign-game',
  //assign Tagger
  assignTagger: '/v2/assign-period',

  //report
  reportData: '/v2/completed-game-report',
  report: '/v2/report',

  // teams
  getAllTeams: '/v2/teams/status',
  createTeam: '/v2/teams',
  updateTeam: '/v2/teams/:teamId',

  // Requested Token
  requestedTokenList: '/v2/request-tagging/list',

  requestButtonFlag: '/v2/admin/team/setting',
  autoAssign: '/v2/admin/settings/auto-assign',

  // Invoice
  invoiceList: '/v2/invoice',
  invoiceById: '/v2/invoice/:id',
  invoiceGenerate: '/v2/invoice/generate',
  invoicePdf: '/v2/invoice/:id/pdf',
  invoiceSendEmail: '/v2/invoice/:id/send-email',
  invoiceClients: '/v2/invoice/clients',
  invoicePricing: '/v2/invoice/pricing',
};
export default PAGE_ROUTES;

export const GAME_STATUS = [
  'CREATED',
  'IN_PROGRESS',
  'IN_QC',
  'QC_COMPLETE',
  'UNDER_REVIEW',
  'CANCELED',
  'COMPLETED',
];

export const PERIOD_STATUS = [
  'UNASSIGNED',
  'READY_FOR_TAGGING',
  'ASSIGNED',
  'IN_PROGRESS',
  'CORRECTION',
  'TAGGING_COMPLETED',
  'FINISHED',
];

export const PERIOD_TABS = [
  'ASSIGNED',
  'READY_FOR_TAGGING',
  'IN_PROGRESS',
  'TAGGING_COMPLETED',
  'CORRECTION',
  'FINISHED',
];

export const ROLE_IDS = {
  ADMIN: 1,
  MODERATOR: 2,
  TAGGER: 3,
  SUPER_ADMIN: 4,
  TECHLEAD: 5,
};

export const hasRole = (roleId: number, allowedRoles: number[]) =>
  allowedRoles.includes(roleId);

export const ROLE_MAP_filter: {
  [key: number]: 'admin' | 'moderator' | 'tagger' | 'super_admin';
} = {
  1: 'admin',
  2: 'moderator',
  3: 'tagger',
  4: 'super_admin',
};

export const PRIORITY: {
  [key: number]: 'MINOR' | 'NORMAL' | 'MAJOR' | 'CRITICAL' | 'SHOW_STOPPER';
} = {
  0: 'MINOR',
  1: 'NORMAL',
  2: 'MAJOR',
  3: 'CRITICAL',
  4: 'SHOW_STOPPER',
};
export const permissions: any = {
  SWITCH: 'SWITCH',
  MIDDELE: 'MIDDELE',
  PARENTUSER: 'PARENTUSER',
};
export const UserPermissions: any = {
  1: [permissions.MIDDELE],
  2: [permissions.SWITCH, permissions.PARENTUSER],
};

export const DATABASE_STATUS_TYPE = {
  ACTIVE: 1,
  IN_ACTIVE: 2,
  SOFT_DELETE: 3,
};

export const NOTIFICATION_DURATION = {
  LAST_1_HOUR: 1,
  LAST_8_HOUR: 2,
  LAST_24_HOUR: 3,
  LAST_3_DAYS: 4,
  LAST_7_DAYS: 5,
};
export const dateFormat = 'YYYY-MM-DD';
export const timeFormat = 'hh:mm a';
export const getIp = async () => {
  try {
    const ip: any = await fetch('https://api.ipify.org?format=json');
    const ip2 = await ip.json();
    return ip2?.ip;
  } catch (error) {
    return '0.0.0.0';
  }
};

export const BROADCAST_NOTIFICATION_TYPE = {
  success: 1,
  info: 2,
  warning: 3,
  error: 4,
};

export const formatSecondsToDHMS = (
  totalSeconds: number | string | null | undefined
): string => {
  if (totalSeconds === null || totalSeconds === undefined) return '';
  const secNum = Number(totalSeconds);
  if (Number.isNaN(secNum)) return '';
  const s = Math.max(0, Math.floor(secNum));
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  const HH = String(hours).padStart(2, '0');
  const MM = String(minutes).padStart(2, '0');
  const SS = String(seconds).padStart(2, '0');
  // Matches requested token form "Dayd:HHh:MMm:SS:s" as closely as possible
  return `${days}d:${HH}h:${MM}m:${SS}:s`;
};
